import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";

import "react-datetime/css/react-datetime.css";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../actions/useaxios";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

// import { LoadToast, updateToast } from "../../actions/common";
function subscribelists() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  console.log("stateeeeee", state, location);
  const [sublists, setSublists] = useState([]);
  const [datas, SetDatas] = useState([]);
  const [showtable, setshowtable] = useState(true);
  const [PaginationData, SetPaginationData] = useState({ page: 1, sizePerPage: 5 })
  // const [subselect, setSubselect] = useState([])
  const[loader,Setloader] = useState(false);
  console.log("select", sublists);
  const { toggle } = useSelector((state) => state.admin_panel.User);

  // const [selectdata, setSelectData] = useState([]);
  // console.log('selectdata 111 juju', selectdata)
  const axiosFile = useAxiosFile();

  useEffect(() => {
    showinglists();
  }, []);

  const showinglists = async () => {
    Setloader(true)
    console.log("ddddd");
    var data = await axiosFile.showinglists();
    console.log("vvvv", data);
    setSublists(data?.data);
    // setSubselect(data?.data)
    Setloader(false)
  };

  const submitbtn = async (cell) => {
    console.log("rtg", cell);
    navigate(`/subscribeadd/?id=${cell._id}`);
  };

  // const Datas = [];
  // const subdetailbutton = (e) => {
  //   let cell = e?.target?.id
  //   console.log("uiouioui", cell);
  //   Datas.push(cell);
  //   setSelectData(call)
  //   console.log("fgsfrgtwrtwe", Datas);
  //   if (cell == Datas) {
  //     Datas.pop(cell)
  //   }
  // }
  console.log("dsijskhfsf", datas);
  const subdetailbutton = (e, email) => {
    Setloader(true);
    setshowtable(false);
    let cell = {
      email: email,
    };
    console.log("subdetailbutton", e.target.checked);
    let instarr = [...datas];
    if (instarr.length > 0) {
      if (e.target.checked) {
        instarr.push(cell);
      }
      else {
        instarr.map((item, i) => {
          console.log("item_datassssss", item, i);
          if (item.email == cell.email) {
            instarr.splice(i, 1);
          }
        });
      }
    } else {
      instarr.push(cell);
    }
    console.log("cell data", cell);
    SetDatas([...instarr]);

    console.log("selectdata", instarr);
    setTimeout(() => {
      setshowtable(true);
      Setloader(false);
    }, [1000])
  };
  console.log("subdetailbuttonoutstate", datas, PaginationData);
  const emailsend = async () => {
    console.log("datsssss", datas);
    if (datas?.length > 0) {
      navigate("/subscribeadd", { state: { email: datas } });
    } else {
      toast.error("Choose Email-Id to send email");
    }
    console.log("eFCSEdvf", datas);
  };

  //   const clickbtn = async (cell) => {

  //     const id= LoadToast()
  //     console.log("ccc", cell);
  //     const updatedata = {
  //       _id: cell._id,
  //       action: "statusupdate",
  //       status: true
  //     }
  //     var data = await axiosFile.newinsert(updatedata)
  //     console.log("ttttttttrue", data);
  //     updateToast(id,data.msg,data.success)
  //     if(data?.success== "success"){
  //         showinglists()
  //     }
  //   }
  const columns = [
    // {
    //   dataField: "S.No",
    //   text: "S.No",
    //   sort: true,
    //   formatter: (cell, row, rowindex) => <div> {rowindex + 1}</div>,
    // },
    {
      dataField: "EmailId",
      text: "EmailId",
      sort: true,
      formatter: (cell, row) => (
        <div dangerouslySetInnerHTML={{ __html: cell }}></div>
      ),
    },

    {
      dataField: "EmailId",
      text: "select",
      sort: true,
      formatter: (cell, row, i) => (
        <>
          {" "}
          {console.log("subdetailbuttonintablee", cell, row, datas)}{" "}
          {
            //
            <label>
              <input
                type="checkbox"
                name="select"
                // value={subselect.includes(cell)?cell:''}
                checked={datas.some((checkdata) => checkdata?.email == cell) ? true : false}
                onChange={(e) => {
                  subdetailbutton(e, cell);
                }}
              />
            </label>
          }
        </>
      ),
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log('pageeeee', page, sizePerPage);
      // SetPaginationData({page: page, sizePerPage: sizePerPage})
    },
    onSizePerPageChange: function (page, sizePerPage) {
      // SetPaginationData({page: page, sizePerPage: sizePerPage})
    },
  });

  const SelectAll = () => {
    Setloader(true)
    setshowtable(false)
    if(datas?.length == sublists?.length && datas?.length > 0){
      SetDatas([]);
    }
    else{
      let setarr = [];
      if(sublists?.length > 0){
        sublists.map((val)=>{
          setarr.push({email:val?.EmailId});
        })
      }
      SetDatas(setarr);
    }
    setTimeout(() => {
      setshowtable(true);
      Setloader(false)
    }, [1000])
  }

  return (
    <>
    {
      loader
      ?
      <Loader/>
      :
      <div>
      <div className="innerpages">
        <div className="orders_pages">
          <Headers />
          <div className="container custom_container px-lg-0">
            <div className="row mx-auto">
              <div className="innerpages_wid px-0">
                <Sidebar />
                <div
                  className={
                    toggle
                      ? "content-sec-inner right_widthset content_without_sidebar"
                      : "content-sec-inner  content_with_sidebar"
                  }
                >
                  <section id="content-wrapper">
                    <div class="row">
                      <div className="top_title_sec">
                        <div>
                          <p className="page_title">Subscribers List</p>
                        </div>
                        {/* <div className="rightsec">
                          <button
                            type="button"
                            className="blue_btn add_deliveryprsn"
                            onClick={() => navigate("/subscribeadd")}
                          >
                            Back
                          </button>

                        </div> */}
                      </div>
                    </div>
                    <div className="row mx-auto mt-4">
                      <div className="sec_border">
                        <div className="d-flex align-items-center justify-content-end gap-2">
                          <input
                            type="checkbox"
                            name="select"
                            checked={ datas?.length == sublists?.length && datas?.length > 0 }
                            onChange={SelectAll}
                          />
                          Select All</div>
                        <div className="row">
                          <div className="ffd_table mar_bot">
                            {
                              showtable
                                ?
                                <BootstrapTable
                                  bootstrap4
                                  keyField="id"
                                  columns={columns}
                                  data={sublists}
                                  pagination={pagination}
                                />
                                :
                                <></>
                            }

                          </div>

                          {/* <div className="rightsec">
                           <button
                            type="button"
                            className="blue_btn add_deliveryprsn"
                            // onClick={() => navigate("/subscribeadd")}
                          >
                            send 
                          </button>
                          </div> */}
                          <div className="rightsec">
                            <button
                              type="button"
                              className="blue_btn add_deliveryprsn dp_btn_hover"
                              onClick={() => {
                                emailsend();
                              }}
                            >
                              send
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    </>
  );
}
export default subscribelists;
